import { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';
import { CalendarEvent } from 'owa-calendar-types';

export const selectedDateChanged = action(
    'dayGrid-selectedDateChanged',
    (scenarioId: string, newDate: OwaDate) => ({
        scenarioId,
        newDate,
    })
);

export const selectedItemChanged = action(
    'dayGrid-selectedItemChanged',
    (scenarioId: string, selectionItem: CalendarEvent) => ({
        scenarioId,
        selectionItem,
    })
);

export const refreshDayGrid = action('dayGrid-refreshDayGrid', (scenarioId: string) => ({
    scenarioId,
}));
